export function pageTitle(title) {
  return {
    title: title + ' - Pollin8',
  }
}
